/* Posterlyy home: hero carousel + row arrows */
(function () {
  'use strict';
  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = root.querySelector('[data-dots]');
    if (!slides.length || root._init) return;
    root._init = 1;
    var i = 0, ms = (Number(root.getAttribute('data-interval')) || 7) * 1000, t = null;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var btns = slides.map(function (s, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Slide ' + (n + 1));
      b.addEventListener('click', function () { go(n); play(); });
      dots.appendChild(b); return b;
    });
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function play() { clearInterval(t); if (!reduce && slides.length > 1) t = setInterval(function () { go(i + 1); }, ms); }
    root.addEventListener('mouseenter', function () { clearInterval(t); });
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', function () { clearInterval(t); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 50) { go(i + (d < 0 ? 1 : -1)); play(); } x0 = null; });
    ['prev', 'next'].forEach(function (d) {
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'h2-arr h2-arr--' + d; a.setAttribute('aria-label', d === 'next' ? 'Next slide' : 'Previous slide');
      a.textContent = d === 'next' ? '→' : '←';
      a.addEventListener('click', function () { go(i + (d === 'next' ? 1 : -1)); play(); });
      root.appendChild(a);
    });
    go(0); play();
  }
  function tw() {
    document.querySelectorAll('.tw2').forEach(function (s) {
      var row = s.querySelector('[data-tw-row]'); if (!row || s._tw) return; s._tw = 1;
      function by(d) { row.scrollBy({ left: d * 320, behavior: 'smooth' }); }
      var p = s.querySelector('[data-tw-prev]'), n = s.querySelector('[data-tw-next]');
      if (p) p.addEventListener('click', function () { by(-1); });
      if (n) n.addEventListener('click', function () { by(1); });
    });
  }
  function pop() {
    document.querySelectorAll('.pop3').forEach(function (s) {
      var row = s.querySelector('.pop3g'); if (!row || s._pop) return; s._pop = 1;
      function by(d) { row.scrollBy({ left: d * 300, behavior: 'smooth' }); }
      var p = s.querySelector('[data-pop-prev]'), n = s.querySelector('[data-pop-next]');
      if (p) p.addEventListener('click', function () { by(-1); });
      if (n) n.addEventListener('click', function () { by(1); });
    });
  }
  function packs() {
    document.querySelectorAll('[data-pack]').forEach(function (p) {
      if (p._p) return; p._p = 1;
      var tag = p.querySelector('.pk3__tag'), out = p.querySelector('[data-price-out]');
      var radios = p.querySelectorAll('input[name="id"]');
      function upd() {
        if (p.hasAttribute('data-mixed')) return;
        var r = p.querySelector('input[name="id"]:checked'); if (!r) return;
        p.setAttribute('data-size', r.getAttribute('data-key') || 'm');
        if (tag) tag.textContent = '10 posters · ' + (r.getAttribute('data-dim') || '');
        if (out) out.textContent = '₹' + Math.round(Number(r.getAttribute('data-price')) / 100).toLocaleString('en-IN');
      }
      Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', upd); });
      upd();
    });
  }
  function boot() { document.querySelectorAll('[data-hero2]').forEach(init); tw(); pop(); packs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
